import { render, staticRenderFns } from "./Block.vue?vue&type=template&id=d21cc2a4&scoped=true&"
import script from "./Block.vue?vue&type=script&lang=js&"
export * from "./Block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21cc2a4",
  null
  
)

export default component.exports